import { render, staticRenderFns } from "./volafly-download.vue?vue&type=template&id=6ff06612"
import script from "./volafly-download.vue?vue&type=script&lang=ts"
export * from "./volafly-download.vue?vue&type=script&lang=ts"
import style0 from "./volafly-download.vue?vue&type=style&index=0&id=6ff06612&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff06612')) {
      api.createRecord('6ff06612', component.options)
    } else {
      api.reload('6ff06612', component.options)
    }
    module.hot.accept("./volafly-download.vue?vue&type=template&id=6ff06612", function () {
      api.rerender('6ff06612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/no-auth/volafly-download.vue"
export default component.exports